import { inmunetApi } from '../../../api';

export const confirmarCita = async({ id }) => {

    try {

        const { data } = await inmunetApi.put(`/cita/confirmar/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al confirmar cita';

        return data.cita;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al confirmar cita');
        }

    }

};

export const cancelarCita = async({ id }) => {

    try {

        const { data } = await inmunetApi.put(`/cita/cancelar/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al cancelar cita';

        return data.cita;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al cancelar cita');
        }

    }

};